import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { PlantService } from 'pages/quote-setup/plants/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(PlantService, DialogService, EventAggregator)
export class Plants {
    constructor(plantService, dialogService, ea) {
        this.ea = ea;
        this.plantService = plantService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'name', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { dataField: 'code' },
            { dataField: 'address' },
            { dataField: 'city' },
            { dataField: 'state', caption: 'State/Province' },
            { dataField: 'zip' },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('plants:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (plant) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.plantService.delete(plant.id);
                this.grid.refresh();
                toastr.success('Plant was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.plantService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.plantService.editor, model: { id: data.id } });
    };
}